module.exports = "$ npm install great-component --save\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src-docs/app/snippets/installation.js
 ** module id = 242
 ** module chunks = 2
 **/